<app-data-table-container class="max-h-[calc(52px*5)] border border-gray-200">
  <table mat-table [dataSource]="dataSource()">
    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef>Naam</th>
      <td mat-cell *matCellDef="let element">
        <span
          class="w-min max-w-40 truncate block"
          [matTooltip]="element.label"
          matTooltipPosition="after"
          >{{ element.label }}</span
        >
      </td>
    </ng-container>

    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let element">
        @if (!hideActions()) {
          <button mat-icon-button (click)="itemRemove.emit(element.linkId)">
            <mat-icon>delete</mat-icon>
          </button>
        }
      </td>
    </ng-container>

    <tr
      mat-header-row
      *matHeaderRowDef="displayedColumns; sticky: true"
      class="whitespace-nowrap"
    ></tr>
    <tr
      mat-row
      *matRowDef="let row; columns: displayedColumns"
      class="hover:!bg-gray-100 whitespace-nowrap"
    ></tr>

    <tr class="mat-mdc-row" *matNoDataRow>
      <td
        class="mat-mdc-cell mdc-data-table__cell !border-none"
        [colSpan]="displayedColumns.length"
      >
        Geen resultaten gevonden
      </td>
    </tr>
  </table>
</app-data-table-container>
